"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "McpGetOperations", {
    enumerable: true,
    get: function() {
        return McpGetOperations;
    }
});
const _common = require("@nestjs/common");
const _mcpservice = require("~/services/mcp.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let McpGetOperations = class McpGetOperations {
    async handle(context, { req, operation }) {
        switch(operation){
            case 'mcpList':
                return await this.mcpService.list(context, req);
            case 'mcpGet':
                return await this.mcpService.get(context, req.query.tokenId, req);
            case 'mcpRootList':
                return await this.mcpService.listByUserId(context, req);
        }
    }
    constructor(mcpService){
        this.mcpService = mcpService;
        this.operations = [
            'mcpList',
            'mcpGet',
            'mcpRootList'
        ];
        this.httpMethod = 'GET';
    }
};
McpGetOperations = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _mcpservice.McpTokenService === "undefined" ? Object : _mcpservice.McpTokenService
    ])
], McpGetOperations);
